
// INSTALLED 
import { Divider } from '@mui/material';


// CUSTOM 
import { BreadCrumbsAndTitle } from '../../components/generics/BreadCrumbsAndTitle';
import { TableUsuariosPermisos } from '../../components/tables/TableUsuariosPermisos';
import { AlertsInformativos } from '../../components/generics/AlertsInformativos';
import { alertInformativo } from '../../commons/texts/textAlertsInformativos';



/**
 * Component that renders the UsuariosPermisos page.
 * 
 * This page includes:
 * - A breadcrumb and title section with the title "Listado Usuario Permisos".
 * - A divider for visual separation.
 * - A table component (`TableUsuariosPermisos`) that displays user permissions.
 * 
 * @returns {JSX.Element} The rendered UsuariosPermisos page.
 */
export const UsuariosPermisos = () => {
  

  return (


    <>

        
        <BreadCrumbsAndTitle
                      title="Listado Usuario Permisos" 
                      mainModule="configuracion" 
                      parent="Listado Usuario Permisos"
                      action="" />
        
        <AlertsInformativos type={'info'} title={'info'} content={alertInformativo.usuariospermisos} /> 
        <Divider sx={{ marginBottom: 2 }}/>
  
         <TableUsuariosPermisos /> 
    </>

  )

}

